"use strict";

var parse = require("cwise-parser");

var compile = require("cwise-compiler");

var REQUIRED_FIELDS = ["args", "body"];
var OPTIONAL_FIELDS = ["pre", "post", "printCode", "funcName", "blockSize"];

function createCWise(user_args) {
  //Check parameters
  for (var id in user_args) {
    if (REQUIRED_FIELDS.indexOf(id) < 0 && OPTIONAL_FIELDS.indexOf(id) < 0) {
      console.warn("cwise: Unknown argument '" + id + "' passed to expression compiler");
    }
  }

  for (var i = 0; i < REQUIRED_FIELDS.length; ++i) {
    if (!user_args[REQUIRED_FIELDS[i]]) {
      throw new Error("cwise: Missing argument: " + REQUIRED_FIELDS[i]);
    }
  } //Parse blocks


  return compile({
    args: user_args.args,
    pre: parse(user_args.pre || function () {}),
    body: parse(user_args.body),
    post: parse(user_args.post || function () {}),
    debug: !!user_args.printCode,
    funcName: user_args.funcName || user_args.body.name || "cwise",
    blockSize: user_args.blockSize || 64
  });
}

module.exports = createCWise;